import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import user from './user/reducers'
import menu from './menu/reducers'
import settings from './settings/reducers'
import report from './reports/reducer'
import workbook from './workbook/reducer'
import accdetails from './user/accreducer'
export default history =>
  combineReducers({
    router: connectRouter(history),
    user,
    accdetails,
    menu,
    settings,
    report,
    workbook,
  })
